import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@signet/ui/styles.css";
import "@signet/web-kit/styles.css";
import { applyLastTheme } from "@signet/web-kit";
import { App } from "./app.tsx";

applyLastTheme();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
